export default __webpack_public_path__ + "static/media/remingtonBarnArt@2x.680df895.jpg";